module.exports = __webpack_public_path__ + "img/ahhblogo.ad99d330.png";